import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sourceNameResolver: FieldResolver = (metadata: Metadata) =>
  ({ sourceName: metadata.getSourceName() } as StreamData)

export default sourceNameResolver
